import styled from 'styled-components/macro';

const Title = styled.h1`
  width: 100%;
  margin: 0;
  padding: 10px;
  font-weight: normal;
  overflow: hidden;
  font-size: 12px;
  text-align: center;
  color: #fff;
  opacity: 0.6;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
`;

export default Title;
